<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
        </div>
        <div class="widget-content">
          <div class="d-flex justify-content-between align-items-center">
            <h2>Obecność w firmie: {{ months[selectedMonth] }} {{ selectedYear }}</h2>
            <div><span class="mb-2">
                <button class="btn btn-sm btn-outline-secondary ms-2 me-2 mb-2" @click="prevMonth">← {{ prevMonthName
                }}</button>
                <button class="btn btn-sm btn-outline-secondary  mb-2" @click="nextMonth">{{ nextMonthName }} →</button>
              </span>
            </div>
          </div>



          <div class="row mb-3">
            <div class="col-auto d-flex align-items-center me-3">
              <select v-model="selectedDepartament" class="form-select form-sm mb-2" style="width: 360px;"
                @change="changeDepartament">
                <option value="0">WSZYSTKIE DZIAŁY</option>
                <option v-for="(department, depId) in departaments" :key="depId" :value="department.id">{{
                  department.name }}</option>
                <option value="-1">POZOSTALI PRACOWNICY</option>
              </select>
            </div>

            <div class="col-auto d-flex align-items-center me-3">
              <select v-model="selectedMonth" class="form-select form-sm mb-2" style="width: 140px;" @change="loadData">
                <option v-for="(month, index) in months" :key="index" :value="index">{{ month }}</option>
              </select>
            </div>

            <div class="col-auto d-flex align-items-center">
              <select v-model="selectedYear" class="form-select form-sm mb-2" style="width: 140px;" @change="loadData">
                <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
              </select>
            </div>

          </div>

          <div class="rooms-container w-100 overflow-auto"
            style="gap: 1rem; white-space: nowrap; padding-bottom: 0.5rem;">
            <div class="table-responsive w-100">
              <div class="calendar-legend mt-1 mb-3 d-flex justify-content-center gap-3">
                <div class="legend-item d-flex align-items-center">
                  <div
                    style="width: 20px; height: 20px; background-color: red; border: 1px solid #000; margin-right: 6px;">
                  </div>
                  <span>Nieobecny</span>
                </div>
                <div class="legend-item d-flex align-items-center">
                  <div
                    style="width: 20px; height: 20px; background-color: blue; border: 1px solid #000; margin-right: 6px;">
                  </div>
                  <span>Delegacja</span>
                </div>
                <div class="legend-item d-flex align-items-center">
                  <div
                    style="width: 20px; height: 20px; background-color: yellow; border: 1px solid #000; margin-right: 6px;">
                  </div>
                  <span>Przepustka</span>
                </div>
                <div class="legend-item d-flex align-items-center">
                  <div
                    style="width: 20px; height: 20px; background-color: #eee3e3; border: 1px solid #000; margin-right: 6px;">
                  </div>
                  <span>Święto</span>
                </div>
                <div class="legend-item d-flex align-items-center">
                  <div
                    style="width: 20px; height: 20px; background-color: #00bfff; border: 1px solid #000; margin-right: 6px;">
                  </div>
                  <span>Dzień wolny</span>
                </div>
              </div>
              <table class="table table-bordered table-hover text-center w-100">
                <thead>
                  <tr>
                    <th class="border p-1 bg-gray-100 text-start" style="min-width: 100px;"></th>
                    <th v-for="day in daysInMonth" :key="day" class="border p-1"
                      :class="[isToday(day) ? 'bg-Lightblue font-bold' : (isSunday(day) || isSaturday(day)) ? 'bg-gray-100 text-gray' : 'bg-gray-100', isHoliday(getDateString(day)) ? 'bg-holiday text-gray' : '', isHoliday2(getDateString(day)) ? 'bg-holiday2 text-black' : '']">
                      {{ day }}<br>{{ dzientygodnia(day) }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="employee in localUsers" :key="employee.id">
                    <td class="border p-1 text-start" style="min-width: 150px;">
                      <div class="d-flex justify-content-between align-items-center">
                        <strong>{{ employee.name }}{{ employee.umowa_do }}</strong>
                      </div>
                    </td>
                    <td v-for="day in daysInMonth" :key="employee.id + '-' + day"
                      :class="['border p-1 text-center', getStatusClass(employee, day), isHoliday(getDateString(day)) ? 'bg-holiday text-gray' : '', isHoliday2(getDateString(day)) ? 'bg-holiday2' : '', (isSunday(day) || isSaturday(day)) ? 'bg-gray-50 text-gray' : '', (!isSunday(day) && !isSaturday(day) && getStatusClass(employee, day) !== '')]">
                      {{ day }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>


        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import { ref, computed, onMounted } from 'vue';
import { usePermission } from "@/composables/resources/js/composables/permissions.js";
import axios from 'axios'

const { hasPermission } = usePermission();

export default {
  props: {
    users: Array,
    pracownicy: Array,
    departaments: Array,
    departamentId: Number,

  },
  components: { AppLayout, hasPermission },

  data() {
    const today = new Date()
    return {
      localUsers: this.users.map(u => ({ ...u })),
      selectedAbsence: null,
      selectedMonth: today.getMonth(),
      selectedYear: today.getFullYear(),
      selectedDepartament: this.departamentId ?? 1,
      months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
      years: Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - 5 + i),
      employees: [],
      urlopy: Array,
      przepustki: Array,
      hasPermission,
      holidays2: [],
      holidays: [],
    }
  },
  computed: {
    daysInMonth() {
      const lastDay = new Date(this.selectedYear, this.selectedMonth + 1, 0).getDate()
      return Array.from({ length: lastDay }, (_, i) => i + 1)
    },
    prevMonthName() {
      return this.months[(this.selectedMonth + 11) % 12];
    },
    nextMonthName() {
      return this.months[(this.selectedMonth + 1) % 12];
    },


  },
  watch: {
    selectedAbsence(newVal) {
      if (newVal?.raw_typ_urlopu === 100 && this.pracownicy.length > 0) {
        this.form.delegacjaPracownicy = this.pracownicy.filter(prac =>
          newVal.delegowani?.some(d => d.id === prac.id)
        );
      } else {
        this.form.delegacjaPracownicy = [];
      }

      if (newVal) {
        this.dateRange = [new Date(newVal.start), new Date(newVal.end)];
      } else {
        this.dateRange = null;
      }
    },

    selectedMonth() {
      this.loadData();
    },

    selectedYear() {
      this.loadData();
      this.fetchWolne();
    }
  },


  methods: {
    fetchWolne() {
      const rok = this.selectedYear;
      console.log("rok:", rok);

      axios.get(route('wolne.dni', { year: rok }))
        .then(response => {
          this.holidays2 = response.data;
          console.log("holidays:", this.holidays2);
        })
        .catch(error => {
          console.error("Błąd podczas pobierania dni wolnych:", error);
        });
    },


    isHoliday2(dateInput) {
      if (!dateInput) return false;

      const dateStr = typeof dateInput === 'string'
        ? dateInput
        : this.formatDate(dateInput);

      const allHolidays = this.holidays2.flatMap(item => {
        if (item.includes(' - ')) {
          // zakres w formacie "YYYY-MM-DD - YYYY-MM-DD"
          const [start, end] = item.split(' - ').map(s => s.trim());
          const dates = [];
          let current = new Date(start);
          const endDate = new Date(end);

          while (current <= endDate) {
            const yyyy = current.getFullYear();
            const mm = String(current.getMonth() + 1).padStart(2, '0');
            const dd = String(current.getDate()).padStart(2, '0');
            dates.push(`${yyyy}-${mm}-${dd}`);
            current.setDate(current.getDate() + 1);
          }

          return dates;
        } else {
          // pojedyncza data
          const d = new Date(item.trim());
          const yyyy = d.getFullYear();
          const mm = String(d.getMonth() + 1).padStart(2, '0');
          const dd = String(d.getDate()).padStart(2, '0');
          return [`${yyyy}-${mm}-${dd}`];
        }
      });

      return allHolidays.includes(dateStr);
    },

    toggleTable() {
      this.showTable = !this.showTable;
    },

    formatDateToYMD(datetime) {
      if (!datetime) return '';
      const date = new Date(datetime);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    formatDate(date) {
      const d = new Date(date);
      const month = '' + (d.getMonth() + 1);
      const day = '' + d.getDate();
      const year = d.getFullYear();

      return [year, month.padStart(2, '0'), day.padStart(2, '0')].join('-');
    },

    getEmployeeById(userId) {
      return this.localUsers?.find(u => u.id === userId);
    },

    async changeDepartament() {
      try {
        const response = await axios.get(route('kadry.get.users'), {
          params: {
            departament: this.selectedDepartament
          }
        });

        this.localUsers = response.data.users.map(u => ({ ...u }));
        this.loadData();
      } catch (error) {
        console.error('Błąd podczas pobierania pracowników:', error);
      }
    },

    getDateString(day) {
      return `${this.selectedYear}-${(this.selectedMonth + 1).toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    },

    isHoliday(dateInput) {
      if (!dateInput) return false;
      const dateStr = typeof dateInput === 'string' ? dateInput : this.formatDate(dateInput);
      return this.holidays.includes(dateStr);
    },


    onDateRangeChange(args) {
      this.dateRange = args.value;
      if (this.selectedAbsence) {
        this.selectedAbsence.start = this.formatDateForBackend(this.dateRange[0]);
        this.selectedAbsence.end = this.formatDateForBackend(this.dateRange[1]);
      }
    }
    ,
    formatDateForBackend(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },

    getEmployeeById(id) {
      return this.users.find(u => u.id === id);
    },

    async getInfo(day, userId, preserveSelectedAbsence = false) {
      const rok = this.selectedYear;
      const miesiac = this.selectedMonth;
      const user_id = userId;
      const dzien = day;

      try {
        const response = await axios.get(route('urlopy.getinfo.soft'), {
          params: { rok, miesiac, user_id, dzien }
        });

        const data = response.data;
        this.holidays = Array.isArray(data.holidays) ? data.holidays : [];
        this.wnioskiUrlopowe = Array.isArray(data.urlopy) ? data.urlopy : [];

        if (!preserveSelectedAbsence) {
          this.selectedAbsence = this.wnioskiUrlopowe.find(urlop => {
            const start = new Date(urlop.start + 'T00:00:00Z');
            const end = new Date(urlop.end + 'T23:59:59Z');
            const currentDate = new Date(Date.UTC(this.selectedYear, this.selectedMonth, day));
            return currentDate >= start && currentDate <= end;
          }) || null;
        }

        this.urlopy = {};
        this.wnioskiUrlopowe.forEach(u => {
          if (!this.urlopy[u.user_id]) this.urlopy[u.user_id] = [];
          this.urlopy[u.user_id].push(u);
        });

      } catch (error) {
        console.error("Błąd podczas pobierania wniosków urlopowych:", error);
      }
    },



    isToday(day) {
      const today = new Date()
      return (
        day === today.getDate() &&
        this.selectedMonth === today.getMonth() &&
        this.selectedYear === today.getFullYear()
      )
    },


    isSunday(day) {
      const date = new Date(this.selectedYear, this.selectedMonth, day);
      return date.getDay() === 0;
    },
    isSaturday(day) {
      const date = new Date(this.selectedYear, this.selectedMonth, day);
      return date.getDay() === 6;
    },
    dzientygodnia(day) {
      const date = new Date(this.selectedYear, this.selectedMonth, day)
      const dayIndex = date.getDay() // 0 = niedziela, 1 = poniedziałek, ...
      const customAbbreviations = ['N', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'S']
      return customAbbreviations[dayIndex]
    },
    getStatusClass(employee, day) {
      const dateKey = `${this.selectedYear}-${String(this.selectedMonth + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      const status = employee.absences?.[dateKey];

      switch (status) {
        case 'typ100':
          return 'bg-blue';
        case 'nieobecny':
          return 'bg-red';
        case 'przepustka':
          return 'bg-p';
        default:
          return '';
      }
    },
    prevMonth() {
      if (this.selectedMonth === 0) {
        this.selectedMonth = 11;
        this.selectedYear--;
      } else {
        this.selectedMonth--;
      }
    },
    nextMonth() {
      if (this.selectedMonth === 11) {
        this.selectedMonth = 0;
        this.selectedYear++;
      } else {
        this.selectedMonth++;
      }
    },

    async loadData() {
      try {
        const updatedUsers = await Promise.all(this.localUsers.map(async user => {
          const response = await axios.get(route('urlopy.getinfo'), {
            params: {
              rok: this.selectedYear,
              miesiac: this.selectedMonth,
              user_id: user.id,
            }
          });

          const holidays = Array.isArray(response.data.holidays) ? response.data.holidays : [];
          const urlopy = Array.isArray(response.data.urlopy) ? response.data.urlopy : [];
          const przepustki = Array.isArray(response.data.przepustki) ? response.data.przepustki : [];
          if (user.id === this.localUsers[0].id) {
            this.holidays = holidays;
          }

          const absences = {};
          for (const wniosek of urlopy) {
            const start = new Date(wniosek.start + 'T00:00:00Z');
            const end = new Date(wniosek.end + 'T23:59:59Z');
            let d = new Date(start);

            while (d <= end) {
              const key = d.toISOString().split('T')[0];
              if (wniosek.status === 1 && wniosek.typ_id != 25) {
                absences[key] = String(wniosek.typ_id) === '100' ? 'typ100' : 'nieobecny';
              }
              d.setDate(d.getDate() + 1);
            }
          }

          for (const wniosekp of przepustki) {
            const d = new Date(wniosekp.data_wyjscia + 'T00:00:00Z');
            const key = d.toISOString().split('T')[0];

            absences[key] = 'przepustka';
          }

          return {
            ...user,
            absences,
          };
        }));

        this.localUsers = updatedUsers;

      } catch (error) {
        console.error("Błąd przy pobieraniu danych:", error);
      }
    }



  },
  mounted() {
    this.loadData();
    this.fetchWolne();
  }
}
</script>

<style scoped>
table th,
table td {
  min-width: 32px;
  height: 32px;
  text-align: center;
}

.bg-red {
  background-color: red;
  color: white;
}

.bg-p {
  background-color: yellow;
  color: black;
}

.bg-blue {
  background-color: blue;
  color: white;
}

.bg-orange {
  background-color: orange;
  color: white;
}

.bg-Lightblue {
  background-color: #5fb2d8;
}

.bg-gray-100 {
  background-color: #f5f5f5;
}

.bg-gray-50 {
  background-color: #fafafa;
}

.text-gray {
  color: #9ca3af;
}

.cursor-pointer {
  cursor: pointer;
}

.text-blue {
  color: #3b82f6;
}

.text-white {
  color: white;
}

.calendar-legend .legend-item div {
  border-radius: 3px;
}

.bg-holiday {
  background-color: #eee3e3 !important;
}

.bg-holiday2 {
  background-color: #00bfff !important;
}
</style>
